var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex" }, [
    _c("div", { staticClass: "w-1/3 mb-6 mr-2" }, [
      _c("label", { staticClass: "invisible", attrs: { for: "image" } }, [
        _vm._v("\n            Image*\n        "),
      ]),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "file" },
        on: {
          change: function ($event) {
            return _vm.processFile($event)
          },
          input: _vm.updateForm,
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "w-1/3 mb-6 mr-2" }, [
      _c("label", { staticClass: "invisible", attrs: { for: "url" } }, [
        _vm._v("\n            Url*\n        "),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'",
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.url,
            expression: "url",
          },
        ],
        staticClass:
          "w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",
        attrs: { id: "url", type: "text", name: "url", placeholder: "Url" },
        domProps: { value: _vm.url },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.url = $event.target.value
            },
            _vm.updateForm,
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("url"),
              expression: "errors.has('url')",
            },
          ],
          staticClass: "error text-error-red text-lg",
        },
        [_vm._v(_vm._s(_vm.errors.first("url")))]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "w-1/3 mb-6 mr-2" }, [
      _c("label", { staticClass: "invisible", attrs: { for: "title" } }, [
        _vm._v("\n            Title*\n        "),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'",
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.title,
            expression: "title",
          },
        ],
        staticClass:
          "w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline",
        attrs: {
          id: "title",
          type: "text",
          name: "title",
          placeholder: "Title",
        },
        domProps: { value: _vm.title },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.title = $event.target.value
            },
            _vm.updateForm,
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("title"),
              expression: "errors.has('title')",
            },
          ],
          staticClass: "error text-error-red text-lg",
        },
        [_vm._v(_vm._s(_vm.errors.first("title")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }